import { useQuery } from "@tanstack/react-query";
import { redesActivas, type RedKeel } from "../config/networks";

/**
 * Las SERIES DIARIAS del protocolo para el dashboard (Parte 2). Cada red publica un
 * `series.<clave>.json` diminuto (una fila por dia, ya agregado por `indexer-series.py`); aqui se
 * descargan las cuatro y se combinan. Si un fichero no esta —porque el agregador de esa red aun no
 * se ha desplegado— esa red simplemente no suma, y el dashboard lo dice, en vez de inventar ceros.
 */

export type DiaSerie = { d: string; rebal: number; opened: number; fees: number; recover: number };
export const CLAVES_SERIE = ["rebal", "opened", "fees", "recover"] as const;

async function unaRed(clave: RedKeel["clave"]): Promise<DiaSerie[] | null> {
  try {
    const r = await fetch(`/series.${clave}.json?t=${Math.floor(Date.now() / 60000)}`);
    if (!r.ok) return null;
    const d = await r.json();
    return Array.isArray(d.days) ? (d.days as DiaSerie[]) : null;
  } catch {
    return null;
  }
}

export type Series = {
  /** dias por red; una red ausente = sin fichero (agregador no desplegado ahi) */
  porRed: Partial<Record<RedKeel["clave"], DiaSerie[]>>;
  /** al menos una red publica datos */
  hay: boolean;
  /** redes sin fichero, para avisar honestamente */
  sinDatos: RedKeel["clave"][];
};

export function useSeries() {
  return useQuery({
    queryKey: ["series"],
    staleTime: 120_000,
    refetchInterval: 300_000,
    queryFn: async (): Promise<Series> => {
      const claves = redesActivas().map((r) => r.clave);
      const res = await Promise.all(claves.map((c) => unaRed(c)));
      const porRed: Series["porRed"] = {};
      const sinDatos: RedKeel["clave"][] = [];
      claves.forEach((c, i) => {
        if (res[i]) porRed[c] = res[i]!;
        else sinDatos.push(c);
      });
      return { porRed, hay: Object.keys(porRed).length > 0, sinDatos };
    },
  });
}
